import React from "react"
import { useTranslation } from "react-i18next"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants"
import { stringFormatting, convertM2ToHectareParseFloat } from "../../../../../helpers/TextHelper"
import { UNIT_STRING } from "../../../../../../constants/StringConstant.js"

const OverviewArea = ({ dataInit }) => {
  const { t } = useTranslation()

  const dataArea = (
    <div className={"d-flex"}>
      {stringFormatting(dataInit?.area?.length)} lahan{" "}
      <span className={"font-weight-normal ml-1"}>
        <div className={"d-flex align-items-center"}>
          {`(${stringFormatting(convertM2ToHectareParseFloat(dataInit?.total_land_area), UNIT_STRING.HA)})`}
        </div>
      </span>
    </div>
  )

  const TextLabel = ({ icon, title, description }) => {
    return (
      <>
        <div className={"d-flex align-items-center flex-lg-fill mr-5 mb-2"}>
          <span className="mr-4 rounded-circle p-3 bg-tertiary-soft">
            <SVG src={toAbsoluteUrl(icon)} />
          </span>
          <div className="d-flex flex-column text-dark-75">
            <span className="color-gray">{title}</span>
            <span style={{ fontWeight: 500 }}>{description}</span>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className={"d-flex align-items-center bg-white rounded py-4 px-8 mb-4"}>
      <TextLabel
        icon={ICON_CONSTANTS.MITRA_2}
        title={t("label_mitra")}
        description={dataInit?.mitra_name}
      />
      <TextLabel
        icon={ICON_CONSTANTS.SUB_REGIONAL}
        title={t("label_number_selected_area")}
        description={dataArea}
      />
    </div>
  )
}

export default React.memo(OverviewArea)